import { Component } from '@angular/core';


/* istanbul ignore next */
/* Code coverage having problems with no statements in classes */
export class SkyPageSummaryTitleComponent { static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-page-summary-title',
  template: `<h1 class="sky-page-summary-title">
  <ng-content></ng-content>
</h1>
`,
  styles: [`.sky-page-summary-title {
  font-family: "Blackbaud Sans Condensed", "Helvetica Neue Condensed", "Arial Narrow";
  color: #282b31;
  font-weight: 300;
  font-size: 34px;
  margin-top: 0;
  margin-bottom: 5px;
}
`]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
